'use client'

import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import TileSwiper from '@/src/components/commons/generics/TileSwiper/TileSwiper'
import NumberedHeader from '@/src/components/commons/generics/NumberedHeader/NumberedHeader'
import styles from './NewThreatResearch.module.scss'
import { useQuery } from '@apollo/client/react'
import { BlogGraphQLResponse } from '@/src/app/blogs/Blogs.interface'
import { BLOG_SEARCH_QUERY } from '@/src/app/blogs/Blogs.graphql'
import { getFormattedDate } from '@/src/utils/common'
import Skeleton from '../commons/generics/Skeleton/Skeleton'

const NewThreatResearch = () => {
  const [isClient, setIsClient] = useState(false) // safety check to make sure swiper is ready to init
  const [reqInfo, setReqInfo] = useState([])
  const txtNumber = '04'
  const txtTitle = 'New Threat Research'
  const txtSeeAllResearch = 'SEE ALL RESEARCH'

  const { data, loading, error } = useQuery<BlogGraphQLResponse>(BLOG_SEARCH_QUERY, {
    variables: { limit: 8, offset: 0 },
  })

  useEffect(() => {
    if (data) {
      const formattedData = data?.blogsGraphql?.entities?.map((item) => ({
        id: item?.nid,
        category: item?.fieldBlogMainCategory?.entity?.name?.toUpperCase(),
        title: item?.title,
        // readTime: '4 MIN READ',
        date: getFormattedDate(item?.publishedAt?.value),
        author: item?.entityOwner?.fieldName,
        // authorImg: '/assets/images/threatResearch/profile.jpg',
        image: item?.fieldCoverImage?.entity?.url,
        imageAlt: item?.fieldCoverImage?.alt,
        ctaLink: item?.path?.alias,
        ctaText: 'READ BLOG',
      }))
      setReqInfo(formattedData)
    }
  }, [data, error])

  // Set client state
  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <div className={`${styles.threatResearch} w-full bg-white font-dm-mono p-0`}>
      <div className={`${styles.container} max-w-[1440px] my-0 mx-auto relative`}>
        <div className="mb-[30px] lg:mb-[33px] relative flex justify-between items-center">
          <NumberedHeader
            number={txtNumber}
            title={txtTitle}
            variant="red" //red | gray
            className="mb-0!"
          />
          {/* desktop see all */}
          {isClient && (
            <Link
              href="/blogs"
              className={`
                ${styles.seeAll} 
                hidden md:flex! mr-[20px] lg:mr-[0px] no-underline 
                uppercase text-[14px] font-medium tracking-[1px]
              `}
            >
              {txtSeeAllResearch}
            </Link>
          )}
        </div>

        {error ? (
          <p className="text-[24px]">Unable to load data ...</p>
        ) : loading ? (
          <LoadingCards />
        ) : (
          reqInfo?.length > 0 && <TileSwiper variant="threatResearch" data={reqInfo} />
        )}

        {isClient && (
          <Link
            href="/blogs"
            className={`${styles.seeAll} inline-block md:hidden mr-[20px] no-underline uppercase text-[14px] font-medium tracking-[1px] mt-[30px]`}
          >
            {txtSeeAllResearch}
          </Link>
        )}
      </div>
    </div>
  )
}

export default NewThreatResearch

const LoadingCards = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pr-[20px] lg:pr-0">
      {Array.from({ length: 4 }).map((item, i: number) => (
        <Skeleton key={i} height="20rem" width="100%" count={1} />
      ))}
    </div>
  )
}
